export interface ArtifactDataMemoryEntry {
  id: string
  value: unknown
}

export class ArtifactStore {
  private readonly values = new Map<string, unknown>()
  private readonly listeners = new Set<() => void>()
  private snapshot: ArtifactDataMemoryEntry[] = []

  set(id: string, data: unknown): void {
    this.values.set(id, data)
    this.refresh()
  }

  get(id: string | undefined): unknown {
    if (!id) return undefined
    return this.values.get(id)
  }

  clear(): void {
    this.values.clear()
    this.refresh()
  }

  list(): ArtifactDataMemoryEntry[] {
    return this.snapshot
  }

  subscribe(listener: () => void): () => void {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }

  private refresh(): void {
    this.snapshot = Array.from(this.values.entries()).map(([id, value]) => ({id, value}))
    this.listeners.forEach(listener => listener())
  }
}

/** Compatibility store used by the current single-chat UI. Runtime code can inject its own ArtifactStore. */
export const defaultArtifactStore = new ArtifactStore()

export function setArtifactData(id: string, data: unknown): void {
  defaultArtifactStore.set(id, data)
}

export function getArtifactData(id: string | undefined): unknown {
  return defaultArtifactStore.get(id)
}

export function clearArtifactDataMemory(): void {
  defaultArtifactStore.clear()
}

export function listArtifactDataMemoryEntries(): ArtifactDataMemoryEntry[] {
  return defaultArtifactStore.list()
}

export function subscribeArtifactDataMemory(listener: () => void): () => void {
  return defaultArtifactStore.subscribe(listener)
}
